import { View } from './view';
import { useSelector } from 'react-redux';
import { isDemoModeSelector } from '../../../redux/selectors';

export const DemoModeAlert = () => {
    const isDemoMode = useSelector(isDemoModeSelector);

    return View({ isDemoMode });
};
